module.exports = __webpack_public_path__ + "static/media/proffile-logo.467a7bbb.svg";